'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");

function armorPiece(json) {
  var name = Json_decode.field("Name", Json_decode.string, json);
  var imageName = name.replace(/ /g, "_");
  return {
          name: name,
          image: "https://pvpmanager.dark-gaming.com/img/" + imageName + ".png",
          netId: Json_decode.field("NetID", Json_decode.$$int, json),
          baseDefense: Json_decode.field("BaseDefense", Json_decode.$$int, json),
          currentDefense: Json_decode.field("CurrentDefense", Json_decode.$$int, json),
          baseMeleeDamagePercentage: Json_decode.field("BaseMeleeDamagePercentage", Json_decode.$$int, json),
          baseMagicDamagePercentage: Json_decode.field("BaseMagicDamagePercentage", Json_decode.$$int, json),
          baseRangedDamagePercentage: Json_decode.field("BaseRangedDamagePercentage", Json_decode.$$int, json),
          baseMinionDamagePercentage: Json_decode.field("BaseMinionDamagePercentage", Json_decode.$$int, json),
          currentMeleeDamagePercentage: Json_decode.field("CurrentMeleeDamagePercentage", Json_decode.$$int, json),
          currentMagicDamagePercentage: Json_decode.field("CurrentMagicDamagePercentage", Json_decode.$$int, json),
          currentRangedDamagePercentage: Json_decode.field("CurrentRangedDamagePercentage", Json_decode.$$int, json),
          currentMinionDamagePercentage: Json_decode.field("CurrentMinionDamagePercentage", Json_decode.$$int, json)
        };
}

var Decode = {
  armorPiece: armorPiece
};

exports.Decode = Decode;
/* No side effect */
